import { Container, Stack, Title, Card } from "@mantine/core";
import { Board } from "../../common/boards/board.schema";
import SocialShare from "../../common/SocialShare";
import { Event } from "../../common/events/event.schema";
import Results from "./Results";
import { getEventName, getIsTournament } from "./util";
import MemberTable from "../members/MemberTable";
import { Member } from "../../common/members/member.schema";
import USFAEventRating from "./USFAEventRating";

const SummaryComplete = ({ event, board }: { event: Event; board: Board }) => {
  const isTournament = getIsTournament(event);
  return (
    <Container size="sm" pt={10} px={0}>
      <Stack>
        <Title order={4}>{getEventName(event)} complete</Title>
        <USFAEventRating event={event} />
        {isTournament && (
          <>
            <Results event={event} />
            <Card>
              <Stack>
                <Title order={3} size="xs">
                  Share final results
                </Title>
                <SocialShare board={board} event={event} />
              </Stack>
            </Card>
          </>
        )}
        {!isTournament && event.members.length > 0 && (
          <MemberTable members={event.members as Member[]} link />
        )}
      </Stack>
    </Container>
  );
};
export default SummaryComplete;
